module.exports = __webpack_public_path__ + "static/media/photo-selfie1.8633a39e.jpg";